import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import type { ChannelTypes } from 'types/Channels.type';
import type { Subcampaign } from 'types/Subcampaign.type';

export const CCM_OFFER_TYPE_POOL = 'pool';
export const CCM_OFFER_TYPE_ACCEPTED = 'accepted';
export const CCM_OFFER_TYPE_REVOKED = 'revoked';

export const CCM_OFFER_TYPES = [
  CCM_OFFER_TYPE_POOL,
  CCM_OFFER_TYPE_ACCEPTED,
  CCM_OFFER_TYPE_REVOKED
];

export const CCM_OFFER_TYPE_TO_STATE_MAP = {
  [CCM_OFFER_TYPE_POOL]: {
    state: CCM_OFFER_TYPE_POOL,
    overviewName: 'poolOverview'
  },
  [CCM_OFFER_TYPE_ACCEPTED]: {
    state: CCM_OFFER_TYPE_ACCEPTED,
    overviewName: 'acceptedOverview'
  },
  [CCM_OFFER_TYPE_REVOKED]: {
    state: CCM_OFFER_TYPE_REVOKED,
    overviewName: 'revokedOverview'
  }
};

export const isParticipantTypeSupported = (
  type: string
): boolean => (
  CCM_OFFER_TYPES.includes(type)
);

const getChannelTypes = (): Set<ChannelTypes> => {
  const uniqTypes = new Set<ChannelTypes>();

  uniqTypes.add('instagram');
  uniqTypes.add('tiktok');

  return uniqTypes;
};

export const CCM_CHANNEL_TYPES: Set<ChannelTypes> = getChannelTypes();

export const hasSubmittedOutfits = (
  subcampaigns: Array<Subcampaign>
): boolean => (
  (subcampaigns || []).some(subcampaign => {
    const outfits = subcampaign.offer?.deliverablesOverview?.zalandoOutfit;

    if (isNil(outfits) || isEmpty(outfits)) {
      return false;
    }

    return outfits.some(outfit => (
      !isNil(outfit.outfitMetadata) && !isEmpty(outfit.outfitMetadata))
    );
  })
);
